if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

      /* A COMPRA RAPIDA PASSOU A PEDIR O TAMANHO (07/09/2026, decisao do Gus).

         Antes: a janela abria com a PRIMEIRA variante ja escolhida e o botao
         "Adicionar ao carrinho" levava essa variante pro carrinho. O cliente
         nunca dizia o tamanho.

         Por que: o seletor desta loja (`will-dobra-produto.liquid`) nao usa o
         `variant-radios`/`variant-selects` do Dawn. Ele usa LINKS de verdade
         (`<a href="{{ v.url }}">`). Na pagina do produto isso funciona, porque
         o link navega e o servidor devolve a pagina com a variante certa.
         Dentro da janela o mesmo link levava o navegador inteiro pra outra
         pagina — o cliente saia da home e a "compra rapida" acabava ali.

         Agora: o clique no cartao de tamanho (ou no nome da cor) e interceptado
         aqui. Em vez de navegar, buscamos a MESMA url por tras (fetch) e
         trocamos so o conteudo da janela. O formulario de compra vem junto,
         entao o `<input name="id">` sempre carrega a variante que esta marcada
         na tela. Nao existe caminho em que o botao adicione outra coisa.

         O listener fica no `modalContent`, que nunca e substituido — so os
         filhos dele sao. Por isso basta ligar uma vez, aqui. */
      this.modalContent.addEventListener('click', this.aoClicarNaVariante.bind(this));
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      this.carregarProduto(opener.getAttribute('data-product-url'))
        .then(() => {
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    /* Busca a pagina do produto e injeta a secao MainProduct dentro da janela.
       Serve pra abertura (show) E pra troca de variante — e o mesmo trabalho,
       so muda a url. Retorna a Promise pra quem chamou saber quando acabou. */
    carregarProduto(url) {
      return fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          this.abrirEscolhaDeCor();
        });
    }

    /* A cor mora num <details> FECHADO por padrao. Na pagina cheia isso e certo:
       economiza 57px e a cor e refinamento, nao decisao (ver o comentario em
       will-dobra-produto.liquid). Dentro da janela e errado: fechado, ele parece
       um rotulo, e o cliente nunca descobre que da pra trocar de cor.

       Abrimos so aqui, por JS, com o atributo nativo `open`. A pagina normal
       nao muda em nada. */
    abrirEscolhaDeCor() {
      this.modalContent.querySelectorAll('details.will-dobra__cores').forEach((detalhe) => {
        detalhe.open = true;
      });
    }

    /* O clique no cartao de tamanho ou no nome da cor, DENTRO da janela.
       Delegado: os links sao recriados a cada troca, entao nao da pra ligar o
       listener neles um a um. */
    aoClicarNaVariante(event) {
      const link = event.target.closest('.will-dobra__cartao, .will-dobra__cor');
      if (!link) return;

      const url = link.getAttribute('href');
      if (!url) return;

      // Sem isso o navegador sai da home e a "compra rapida" perde o sentido.
      event.preventDefault();

      // Dois cliques seguidos podiam chegar fora de ordem e deixar a tela
      // mostrando um tamanho e o formulario carregando outro.
      if (this.trocandoVariante) return;
      this.trocandoVariante = true;

      const ehCor = link.classList.contains('will-dobra__cor');
      const caixa = this.querySelector('.quick-add-modal__content');
      const rolagem = caixa ? caixa.scrollTop : 0;

      this.modalContent.setAttribute('aria-busy', 'true');

      this.carregarProduto(url)
        .then(() => {
          // O conteudo e novo, entao a rolagem volta ao topo sozinha. Devolver
          // a posicao mantem o seletor onde o olho do cliente ja estava.
          if (caixa) caixa.scrollTop = rolagem;

          const marcado = this.modalContent.querySelector(
            ehCor ? '.will-dobra__cor--ativa' : '.will-dobra__cartao--ativo'
          );
          if (marcado) marcado.focus({ preventScroll: true });
        })
        .catch((erro) => {
          // Se a busca falhar, o link volta a ser o que sempre foi: navegacao.
          // Pior caso o cliente vai parar na pagina do produto, onde escolher
          // tamanho funciona de qualquer jeito.
          console.error(erro);
          window.location.href = url;
        })
        .finally(() => {
          this.trocandoVariante = false;
          this.modalContent.removeAttribute('aria-busy');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const seletor = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!seletor) return; // PDP com will-dobra nao emite variant-radios/variant-selects do Dawn
      seletor.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      if (!product) return;
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
